<template></template>

<script setup lang="ts">
import { onBeforeUnmount, watchEffect } from 'vue'
import { usePage } from '@inertiajs/vue3'

const page = usePage()

const removeStructuredData = () => {
    document.querySelectorAll('script[data-clipfinder-structured-data]').forEach((element) => element.remove())
}

watchEffect(() => {
    const structuredData = (page.props.seo as { structured_data?: Record<string, unknown>[] } | undefined)?.structured_data ?? []

    removeStructuredData()

    structuredData.forEach((data) => {
        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.dataset.clipfinderStructuredData = ''
        script.textContent = JSON.stringify(data)
        document.head.appendChild(script)
    })
})

onBeforeUnmount(removeStructuredData)
</script>
